const uuid = require('uuid');
const Promise = require('bluebird');
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Button, Modal } from 'react-bootstrap';
const _ = {
    filter:     require('lodash/filter'),
    find:       require('lodash/find'),
    findIndex:  require('lodash/findIndex'),
    forEach:    require('lodash/forEach'),
    map:        require('lodash/map'),
}

const Globals = require('../../../../app/globals');
const ShortCourseConstants = require('../../../../app/shared/ShortCourseConstants');

import SortableTable2 from '../table/SortableTable2';
import AccessibleIcon from '../common/AccessibleIcon';
import ControlledInput from '../common/ControlledInput';
import ControlledTextArea from '../common/ControlledTextArea';
import SingleAssetInput from '../common/SingleAssetInput';
const GotoCommentIcon = require('./sidebar/GotoCommentIcon');

const ShortCourseActions = require('../../actions/ShortCourseActions');
const ShortCourseStore = require('../../stores/ShortCourseStore');

const ActivityActions = require('../../actions/ActivityActions');
const ActivityStore = require('../../stores/activity_store_reflux');

const ShortCourseEditorActions = require('../../actions/ShortCourseEditorActions');
const ShortCourseEditorStore = require('../../stores/ShortCourseEditorStore');

const KeyboardUtil = require('../../util/keyboard');
const AssetUtil = require('../../util/asset');
const ReactMzlUtils = require('../../util/ReactMzlUtils');

const Strings = require('../../../../app/shared/Strings');

import ShortCourseActivityChooser from './ShortCourseActivityChooser';
import EditActivityDetailsModal from './EditActivityDetailsModal';
import EditSubskillModal from './EditSubskillModal';
import RSDPickerModal from './RSDPickerModal';
import EditChatbotActivityModal from './EditChatbotActivityModal';

const propTypes = {
    node: PropTypes.object.isRequired,
    projects: PropTypes.object.isRequired, // keyed by project id
    activities: PropTypes.array.isRequired,
    templates: PropTypes.object, // keyed by template id
    openConfirmModal: PropTypes.func.isRequired,
    courseHash: PropTypes.string.isRequired,
    commentProps: PropTypes.object,
    activityTypes: PropTypes.array,
};
const defaultProps = {};

const ASSESSMENT_ACTIVITY_TYPES = Globals.short_course.ASSESSMENT_ACTIVITY_TYPES;
const REMEDIAL_ACTIVITY_TYPES = Globals.short_course.REMEDIAL_ACTIVITY_TYPES;
const TUTORIAL_ACTIVITY_TYPES = Globals.short_course.TUTORIAL_ACTIVITY_TYPES;

class ShortCourseNodeEditor extends React.Component {
    constructor(props) {
        super(props);
        let storeState = ShortCourseEditorStore.getState();
        const doc = storeState.shortCourseDoc;
        const activity_types = storeState.shortCourseDoc.activity_types;
        const subskills = _.filter(doc.subskills,(ss)=>(!!ss.node_relations[props.node.node_id]));
        const activityScoreCategories = ActivityStore.getStateScoreCategories().activityScoreCategories;
        this.state = { doc, subskills, activityScoreCategories, activity_types };
        this.app = ReactMzlUtils.getAppForSharedComponents({ course_hash: doc.hash, getDoc: ()=>{ return this.state.doc; } }); // for react-mzl
        this.unsubscribes = [
            ShortCourseStore.listen(this.onStoreChange),
            ShortCourseEditorStore.listen(this.onEditorChange),
            ActivityStore.listen(this.onActiviyStoreChange),
            ];
    }
    
    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
        delete this.unsubscribes; // used as an indicator for the component no longer being mounted
    }
    
    onStoreChange=(storeState)=>{
        let imageUpdateActionID = this.state.imageUpdateActionID;
        if (storeState.action) {
            if (storeState.action.id === imageUpdateActionID) {
                imageUpdateActionID = null;
                if (storeState.action.error) {
                    console.log("upload error",storeState.action.error); // TODO: display this?
                }
            }
        }
        this.setState({imageUpdateActionID});
    }
    
    onActiviyStoreChange=()=>{
        const activityScoreCategories = ActivityStore.getStateScoreCategories().activityScoreCategories;
        this.setState({activityScoreCategories,actionId_score_categories:null});
    }
    
    onEditorChange=(storeState)=>{
//        if (!storeState.action) {
//            return;
//        }
//        switch(storeState.action.name) {
//            case 'addSubskillToNode':
//            case 'deleteSubskillFromNode':
//            case 'setSubskillValue':
//                break;
//            default:
//                return;
//        }
        const doc = storeState.shortCourseDoc;
        const subskills = _.filter(doc.subskills,(ss)=>(!!ss.node_relations[this.props.node.node_id]));
        const edit_activity_id = this.state.edit_activity_id;
        let edit_subskill_relations = this.state.subskill_relations;
        if (edit_activity_id) {
            const cb = _.find(doc.content_blocks,{nova_activity_id:edit_activity_id});
            if (cb) {
                edit_subskill_relations = cb.subskill_relations;
            }
            else {
                console.log(`didn't find content block ${edit_activity_id}`);
                edit_subskill_relations = {};
            }
        }
        
        this.setState({doc,subskills, edit_subskill_relations});

        if (storeState.action && (storeState.action.name === 'addSubskillToNode') && storeState.action.new_ss_hash) {
            this.openSubskillEditor(storeState.action.new_ss_hash);
        }
    }
    
    onSelectPrerequisite=(e)=>{
        let prereq_id = e.target.value;
        if (prereq_id) {
            ShortCourseEditorActions.addPrereq(uuid.v4(),this.props.node.node_id,prereq_id);
        }
    }
    
    onRemovePrerequisite=(prereq_id)=>{
        ShortCourseEditorActions.removePrereq(uuid.v4(),this.props.node.node_id,prereq_id);
    }
    
    setNodeValue=(key,evt)=>{
        ShortCourseEditorActions.setNodeValue(uuid.v4(),this.props.node.node_id,key,evt.target.value);
    }

    addingPrereqWouldCreateLoop=(node,preNode)=>{
        return false; // TODO
    }
    
    onAddActivity=(activity_type, id)=>{
        const activity = _.find(this.props.activities,{id});
        if (!activity) {
            return;
        }
        
        return this.asyncGetScoreCategoriesForActivity(activity)
        .then((score_categories)=>{
            if (!score_categories) {
                score_categories = [];
            }
            ShortCourseEditorActions.addContentBlockToNode(uuid.v4(),{
                node_id: this.props.node.node_id, 
                nova_activity_id: activity.activity_id, 
                activity_version: activity.version, 
                activity_type, score_categories,
            });
        })
        .catch((err)=>{
            console.log("error getting score_categories. adding activity anyway",err); // FIXME: remove debug spam
            ShortCourseEditorActions.addContentBlockToNode(uuid.v4(),{
                node_id: this.props.node.node_id, 
                nova_activity_id: activity.activity_id, 
                activity_version: activity.version, 
                activity_type, 
                score_categories: [],
            });
        });
    }
    
    openEditChatbotModal=(chatbot_activity_hash,preview)=>{
        let modalData;
        if (chatbot_activity_hash === 'add') {
            modalData = {
                op: 'add',
                data: null
            };
        }
        else {
            let cb = _.find(this.state.doc.content_blocks,{chatbot_activity_hash});
            if (!cb) {
                console.log(`unable to find content block with chatbot_activity_hash ${chatbot_activity_hash}`);
                return;
            }
            modalData = {
                op: 'edit',
                data: cb,
                preview
            };
        }
        this.setState({
            modalState: 'editChatbotActivity',
            modalData,
        });
    }
    
    editChatbotSaveHandler=(chatbotActivityData)=>{
        if (this.state.modalData) {
            chatbotActivityData.node_id = this.props.node.node_id;
            if (this.state.modalData.op === 'add') {
                ShortCourseEditorActions.addChatbotContentBlock(uuid.v4(),chatbotActivityData);
            }
            else {
                ShortCourseEditorActions.updateChatbotContentBlock(uuid.v4(),chatbotActivityData);
            }
        }
        else {
            console.log("no modalData for editChatbotSaveHandler");
        }
        this.closeEditChatbotModal();
    }
    
    closeEditChatbotModal=()=>{
        if (this.state.modalState === 'editChatbotActivity') {
            this.setState({
                modalState: null,
                modalData: null,
            });
        }
    }
    
    onEditChatbotActivity=(chatbot_activity_hash)=>{
        this.openEditChatbotModal(chatbot_activity_hash);
    }
    
    onPreviewChatbotActivity=(chatbot_activity_hash)=>{
        this.openEditChatbotModal(chatbot_activity_hash,true);
    }
    
    onRemoveChatbotActivity=(chatbot_activity_hash)=>{
        let cb = _.find(this.state.doc.content_blocks,{chatbot_activity_hash});
        if (!cb) {
            return;
        }
        this.props.openConfirmModal({
            modalTitle: "Remove Chatbot Activity",
            text: `Are you sure you wish to remove ${cb.display_title || "this activity"}?`,
            confirmHandler: ()=>{ ShortCourseEditorActions.removeChatbotContentBlock(uuid.v4(),chatbot_activity_hash) }
        });
    }
    
    onPreviewActivity=(activity_id)=>{
        this.props.onPreviewActivity(activity_id);
    }
    
    onEditActivity=(edit_activity_id)=>{
        const cb = _.find(this.state.doc.content_blocks,{nova_activity_id:edit_activity_id});
        if (!cb) {
            return;
        }
        const edit_subskill_relations = cb.subskill_relations;
        this.setState({edit_activity_id, edit_subskill_relations});
    }

    getEditActivityType=()=>{
        const nova_activity_id = this.state.edit_activity_id;
        const cb = _.find(this.state.doc.content_blocks,{nova_activity_id});
        if (!cb) {
            return;
        }
        const nr = cb.node_relations[this.props.node.node_id];
        if (!nr) {
            return;
        }
        return nr.activity_type;
    }
    
    asyncGetScoreCategoriesForActivity=(activity)=>{
        // returns true if resolve or reject was called
        var self = this;
        var _doGet = Promise.method(function(tries) {
            if (!self.unsubscribes) {
                throw new Error("component not mounted");
            }
            if (tries > 15) {
                throw new Error("timeout waiting for score_categories");
            }

            let score_categories = self.state.activityScoreCategories && self.state.activityScoreCategories[activity.id];
            if (score_categories && ActivityStore.isScoreCategoryVersion(activity.id, activity.version) ) {
                return score_categories;
            }

            
            if (self.state.actionId_score_categories) {
                // console.log("score_categories pending");
            }
            else {
                const actionId_score_categories = uuid.v4();
                self.setState({actionId_score_categories},()=>{
                    console.log(`requesting score_categories for activity ${activity.id} version ${activity.version}`);
                    ActivityActions.getActivityScoreCategories(actionId_score_categories, activity.id, activity.version);
                });
            }
            
            console.log("waiting 1 second");
            return Promise.delay(1000)
            .then(()=>{
                return _doGet(tries+1);
            });
        });
        return _doGet(1);
    }
    
    getScoreCategoriesForActivity=(activity)=>{
        let score_categories = this.state.activityScoreCategories && this.state.activityScoreCategories[activity.id];
        if (score_categories && ActivityStore.isScoreCategoryVersion(activity.id, activity.version)) {
            return score_categories;
        }
        if (this.state.actionId_score_categories) {
            console.log("already requesting score categories");
            return false;
        }
        
        const actionId_score_categories = uuid.v4();
        setTimeout(()=>{
            this.setState({actionId_score_categories});
            ActivityActions.getActivityScoreCategories(actionId_score_categories, activity.id, activity.version);
        },1);
        return false;
    }
    
    getEditActivityScoreCategories=()=>{
        const nova_activity_id = this.state.edit_activity_id;
        const cb = _.find(this.state.doc.content_blocks,{nova_activity_id});
        if (!cb) {
            return null;
        }
        const activity = _.find(this.props.activities,{activity_id:nova_activity_id});
        if (!activity) {
            console.log(`didn't find ${nova_activity_id}`);
            return null;
        }
        return this.getScoreCategoriesForActivity(activity);
    }
    
    onSetActivityType=(activity_type)=>{
        ShortCourseEditorActions.setContentBlockNodeValue(uuid.v4(),{
            node_id: this.props.node.node_id,
            nova_activity_id: this.state.edit_activity_id, 
            key: 'activity_type',
            value: activity_type
        });
    }
    
    onSetSubskillValue=(ss_hash,key,value)=>{
        const nova_activity_id = this.state.edit_activity_id;
        ShortCourseEditorActions.setContentBlockSubskillValue(uuid.v4(),{
            ss_hash,
            nova_activity_id, 
            key,
            value,
        });
    }
    
    onSyncSubskills=()=>{
        const node_id = this.props.node.node_id;
        const nova_activity_id = this.state.edit_activity_id;
        const score_categories = this.getEditActivityScoreCategories();
        ShortCourseEditorActions.syncContentBlockSubskills(uuid.v4(),{node_id, nova_activity_id, score_categories});
    }

    onRemoveActivity=(activity_id)=>{
        const activity = _.find(this.props.activities,{activity_id}) || {};
		this.props.openConfirmModal({
			modalTitle: "Remove Activity",
			text: `Are you sure you wish to remove ${activity.title || "this activity"}?`,
			confirmHandler: ()=>{ ShortCourseEditorActions.removeContentBlockFromNode(uuid.v4(),this.props.node.node_id,activity_id) }
		});
    }
    
    openSubskillEditor=(hash)=>{
        this.setState({
            subskill_hash: hash,
            modalState: 'subskillEditor',
        });
    }
    
    closeSubskillEditor=()=>{
        if (this.state.modalState === 'subskillEditor') {
            this.setState({
                subskill_hash: null,
                modalState: null,
            });
        }
    }
    
    openRSDPicker=()=>{
        this.setState({
            modalState: 'rsdPicker',
        });
    }

    closeRSDPicker=()=>{
        if (this.state.modalState === 'rsdPicker') {
            this.setState({
                modalState: null,
            });
        }
    }
    
    onSaveRSD=(params)=>{
        let {rsd_service_id,rsd_id,rsd} = params;
        let {name,description} = rsd || {};
        ShortCourseEditorActions.setNodeRSD(uuid.v4(),{node_id: this.props.node.node_id, rsd_service_id, rsd_id});
        ShortCourseEditorActions.setNodeValue(uuid.v4(),this.props.node.node_id, "name",name);
        ShortCourseEditorActions.setNodeValue(uuid.v4(),this.props.node.node_id, "description",description);
        this.closeRSDPicker();
    }
    
    addSubskill=()=>{
        let hash = uuid.v4()
        ShortCourseEditorActions.addSubskillToNode(hash,this.props.node.node_id);
    }
    
    deleteSubskill=(hash)=>{
        ShortCourseEditorActions.deleteSubskillFromNode(uuid.v4(),this.props.node.node_id,hash);
    }
    
    updateImage=(assetParams, files)=>{
        const imageUpdateActionID = uuid.v4();
        let params = {...assetParams, 
            courseHash: this.props.courseHash,
            asset_name: `node ${this.props.node.node_id} image`
        };
        this.setState({ imageUpdateActionID },()=>{
            // after updating state, upload the image
            ShortCourseActions.addShortCourseVersionAsset(imageUpdateActionID, params, files, (asset_url)=>{
                // after uploading the image, set the node url
                ShortCourseEditorActions.setNodeValue(uuid.v4(),this.props.node.node_id,'img_src',asset_url);
            });
        });
    }

    updateImageOnError=(errorMsg)=>{
        window.alert(errorMsg || 'Error');
    }
    
    getActivityTypeDisplayName=(activity_type)=>{
        if (this.props.activityTypes) {
            const entry = _.find(this.props.activityTypes,{id: activity_type});
            if (entry) {
                return entry.name;
            }
        }
        return activity_type; // revert to something at least
    }
    
    renderActivityTable=(activityArray)=>{
        
        let columns = [
            {
                displayName: '',
                key: 'edit_button',
                type: 'id',
                width: '1rem',
            },
            {
                displayName: '',
                key: 'play_button',
                type: 'id',
                width: '1rem',
            },
            {
                displayName: '',
                key: 'delete_button',
                type: 'id',
                width: '1rem',
            },
            {
                displayName: '',
                key: 'activity_type',
                type: 'id',
                width: '12rem',
            },
            {
                displayName: 'Name',
                key: 'name',
                type: 'string',
                width: '18rem',
            },
            {
                displayName: 'Type',
                key: 'type',
                type: 'string',
                width: '15rem',
            },
        ];
        
        return (
            <div className="input-well">
                <div className="activity-table-area">
                    <SortableTable2 hideSearch showTotal={false}
                        classNameTable="font-size-sm"
                        padClassName="pad-cells-sm"
                        rows={activityArray}
                        rowsPerPage={100}
                        uniqueRowKey="activity_id"
                        defaultSort={{ key: 'order', type: 'int', asc: true }}
                        displayColumnCallbacks={{
                            edit_button: (activity_id)=>(
                                <button title="edit" onClick={()=>{this.onEditActivity(activity_id)}}>
                                    <AccessibleIcon className="fa fa-pencil table-button" label="edit"/>
                                </button>
                            ),
                            play_button: (activity_id)=>(
                                <button title="preview activity" onClick={()=>{this.onPreviewActivity(activity_id)}}>
                                    <AccessibleIcon className="fa fa-play-circle-o table-button" label="preview activity"/>
                                </button>
                            ),
                            delete_button: (activity_id)=>(
                                <button title="delete activity" onClick={()=>{this.onRemoveActivity(activity_id)}}>
                                    <AccessibleIcon className="fa fa-trash table-button" label="remove activity"/>
                                </button>
                            ),
                            activity_type: (t)=>(
                                <div>{this.getActivityTypeDisplayName(t)}</div>
                            ),
                        }}
                        columns={columns}
                    />
                </div>
            </div>
        );
    } // renderActivityTable

    renderChatbotActivityTable=(chatActivityArray)=>{
        
        let columns = [
            {
                displayName: '',
                key: 'edit_button',
                type: 'id',
                width: '1rem',
            },
            {
                displayName: '',
                key: 'play_button',
                type: 'id',
                width: '1rem',
            },
            {
                displayName: '',
                key: 'delete_button',
                type: 'id',
                width: '1rem',
            },
            {
                displayName: '',
                key: 'activity_type',
                type: 'id',
                width: '12rem',
            },
            {
                displayName: 'Name',
                key: 'display_title',
                type: 'string',
                width: '18rem',
            },
        ];
        
        return (
            <div className="input-well">
                <div className="activity-table-area">
                    <SortableTable2 hideSearch showTotal={false}
                        classNameTable="font-size-sm"
                        padClassName="pad-cells-sm"
                        rows={chatActivityArray}
                        rowsPerPage={100}
                        uniqueRowKey="hash"
                        defaultSort={{ key: 'order', type: 'int', asc: true }}
                        displayColumnCallbacks={{
                            edit_button: (hash)=>(
                                <button title="edit" onClick={()=>{this.onEditChatbotActivity(hash)}}>
                                    <AccessibleIcon className="fa fa-pencil table-button" label="edit"/>
                                </button>
                            ),
                            play_button: (hash)=>(
                                <button title="preview" onClick={()=>{this.onPreviewChatbotActivity(hash)}}>
                                    <AccessibleIcon className="fa fa-play-circle-o table-button" label="preview activity"/>
                                </button>
                            ),
                            delete_button: (hash)=>(
                                <button title="delete" onClick={()=>{this.onRemoveChatbotActivity(hash)}}>
                                    <AccessibleIcon className="fa fa-trash table-button" label="remove activity"/>
                                </button>
                            ),
                            activity_type: (t)=>(
                                <div>{this.getActivityTypeDisplayName(t)}</div>
                            ),
                        }}
                        columns={columns}
                    />
                </div>
            </div>
        );
    } // renderChatbotActivityTable

    renderActivities=(ACTIVITY_TYPES, title)=>{
        let activityOptions = [];
        if (!this.state.doc) {
            return null;
        }
        const doc = this.state.doc;
        
        let novaActivities = [];
        let chatbotActivities = [];
        
        _.forEach(doc.content_blocks,(cb,index)=>{
            const nr = cb.node_relations[this.props.node.node_id];
            if (!nr) {
                return;
            }
            let isNovaActivity = (cb.type === Globals.short_course.content_block_type.ACTIVITY);
            let isChatBotActivity = (cb.type === Globals.short_course.content_block_type.CHATBOT);
            if (isNovaActivity) {
                const activity_id = cb.nova_activity_id;
                const activity = _.find(this.props.activities,{activity_id});
                if (!activity) {
                    console.log(`did not find activity ${cb.nova_activity_id} for content block ${cb.hash}`);
                    return; // skip this entry
                }
                const name = activity ? activity.title : `activity ${cb.nova_activity_id}`;
                const query = {activity_id, version: cb.activity_version};
                const template = this.props.templates[activity.template_id];
                const nova_activity_type = (template && template.name) || cb.type;
                const order = ACTIVITY_TYPES.indexOf(nr.activity_type);
                if (order < 0) {
                    return; // doesn't match specified ACTIVITY_TYPES filter
                }
                let entry = {
                    activity_id: activity && activity.activity_id,
                    query,
                    type: nova_activity_type, 
                    name,
                    edit_button: activity.activity_id,
                    play_button: activity.activity_id,
                    delete_button:  activity.activity_id,
                    activity_type: nr.activity_type,
                    order
                };
                novaActivities.push(entry);
            }
            else if (isChatBotActivity) {
                const display_title = cb.display_title;
                let order = ACTIVITY_TYPES.indexOf(nr.activity_type);
                if (order < 0) {
                    return; // doesn't match specified ACTIVITY_TYPES filter
                }
                let hash = cb.chatbot_activity_hash;
                let entry = {
                    hash,
                    display_title,
                    edit_button: hash,
                    play_button: hash,
                    delete_button:  hash,
                    activity_type: nr.activity_type,
                    order
                };
                chatbotActivities.push(entry);
            }
            else {
                console.log(`Unhandled content block type ${cb.type}`); // someday: LINK
            }
        });
        
        return (
            <div className="formlike">
                <div className="content-block-area">
                    <label className="activity-label">{title}</label>
                    <div className="float-clear"/>
                    {novaActivities.length ? this.renderActivityTable(novaActivities) : null }
                    {chatbotActivities.length ? this.renderChatbotActivityTable(chatbotActivities) : null }
                </div>
            </div>
        );
    } // renderActivities

    renderTutorialActivities=()=>{
        return this.renderActivities(TUTORIAL_ACTIVITY_TYPES,'Tutorial Activities');
    }
    
    renderRemedialActivities=()=>{
        return this.renderActivities(REMEDIAL_ACTIVITY_TYPES,'Remedial Activities');
    }

    renderAssessmentActivities=()=>{
        return this.renderActivities(ASSESSMENT_ACTIVITY_TYPES,'Assessment Activities');
    }

    
    renderPrerequisiteEditor=()=>{
        let nodeOptions = [];
        if (!this.state.doc) {
            return null;
        }
        const doc = this.state.doc;
        _.forEach(doc.nodes,(n)=>{
            
            if (n.node_id === this.props.node.node_id) {
                return;
            }
            if (this.props.node.prereq_node_ids.indexOf(n.node_id) >= 0) {
                return;
            }
            const nt = ShortCourseEditorStore.determineNodeType(n);
            if (nt === ShortCourseConstants.NODE_TYPES.CompletionNode) {
                return;
            }
            if (this.addingPrereqWouldCreateLoop(this.props.node,n)) {
                return;
            }
            nodeOptions.push(
                <option key={n.node_id} value={n.node_id}>{n.name}</option>
            );
        });
        
        
        let existingPrerequisites = [];
        
        _.forEach(this.props.node.prereq_node_ids,(node_id)=>{
            let preNode = _.find(doc.nodes,{node_id}) || {name:'* invalid *'};
            existingPrerequisites.push({
                node_id,
                name: preNode.name,
                delete_button:  node_id,
            });
        });
        
        return (
            <div className="formlike">
                <label htmlFor="short-course-node-prereq_node_ids">Prerequisite Skill Nodes</label>
                <select id="short-course-node-prereq_node_ids" value='none' onChange={this.onSelectPrerequisite}>
                    <option value='none'>{'Choose Existing Node as Prerequisite'}</option>
                    {nodeOptions}
                </select>
                <div className="input-well">
                    <div className="prereq-table-area">
                        <SortableTable2 hideSearch showTotal={false}
                            classNameTable="font-size-sm" noPad
                            rows={existingPrerequisites}
                            rowsPerPage={100}
                            uniqueRowKey="node_id"
                            defaultSort={{ key: 'name', type: 'string', asc: true }}
                            displayColumnCallbacks={{
                                delete_button: (node_id)=>{ 
                                    return (
                                        <button title="delete prerequisite" onClick={()=>{this.onRemovePrerequisite(node_id)}}>
                                            <AccessibleIcon className="fa fa-trash" label="remove prerequisite"/>
                                        </button>
                                    )
                                }
                            }}
                            columns={[
                                    {
                                        displayName: 'Name',
                                        key: 'name',
                                        type: 'string'
                                    },
                                    {
                                        displayName: '',
                                        key: 'delete_button',
                                        type: 'id'
                                    },
                                ]}
                        />
                    </div>
                </div>
            </div>
        );
    } // renderPrerequisiteEditor
    
    renderSubskills=()=>{
        const subskills = this.state.subskills;
        let subskillRows = _.map(subskills,(ss,i)=>{
            return { ...ss, 
                edit_button: ss.hash,
                delete_button: ss.hash};
        });
        return (
            <div className="formlike">
                <label htmlFor="short-course-node-prereq_node_ids">Subskills</label>
                <div className="input-well">
                    <div className="subskill-table-area">
                        <SortableTable2 hideSearch showTotal={false}
                            classNameTable="font-size-sm" 
                            padClassName="pad-cells-sm"
                            rows={subskillRows}
                            rowsPerPage={100}
                            uniqueRowKey="hash"
                            defaultSort={{ key: 'index', type: 'int', asc: true }}
                            displayColumnCallbacksId={{
                                edit_button: (hash)=>(
                                    <button title="edit subskill" onClick={()=>{this.openSubskillEditor(hash)}}>
                                        <AccessibleIcon className="fa fa-pencil" label="edit subskill"/>
                                    </button>
                                ),
                                delete_button: (hash)=>(
                                    <button title="delete subskill" onClick={()=>{this.deleteSubskill(hash)}}>
                                        <AccessibleIcon className="fa fa-trash" label="delete subskill"/>
                                    </button>
                                )
                            }}
                            columns={[
                                    {
                                        displayName: 'Name',
                                        key: 'display_name',
                                        type: 'string'
                                    },
                                    {
                                        displayName: '',
                                        key: 'edit_button',
                                        type: 'string'
                                    },
                                    {
                                        displayName: '',
                                        key: 'delete_button',
                                        type: 'string'
                                    },
                                ]}
                        />
                    </div>
                </div>
                <button className="btn btn-primary add-subskill-button" onClick={this.addSubskill}>add subskill</button>
            </div>
        );
    } // renderSubskills
    
    renderElements=()=>{
        const doc = this.state.doc;
        const node = this.props.node;
        const nt = ShortCourseEditorStore.determineNodeType(node);
        const isCompletionNode = (nt === ShortCourseConstants.NODE_TYPES.CompletionNode);
        
        let selectedActivities = [];
        let hasTutorialActivity = false;
        _.forEach(doc.content_blocks,(cb,index)=>{
            if (cb.type !== Globals.short_course.content_block_type.ACTIVITY) {
                return;
            }
            const nr = cb.node_relations[this.props.node.node_id];
            if (!nr) {
                return;
            }
            const activity_id = cb.nova_activity_id;
            const activity = _.find(this.props.activities,{activity_id});
            if (!activity) {
                console.log(`did not find activity ${cb.nova_activity_id} for content block ${cb.hash}`);
                return; // skip this entry
            }
            if ( TUTORIAL_ACTIVITY_TYPES.indexOf(nr.activity_type) >= 0) {
                hasTutorialActivity = true;
            }
            selectedActivities.push(activity);
        });
        
        
        return (
            <div className="formlike">
                <div className="formlike course-node-editor-top-section">
                    <div className="formlike">
                        <label htmlFor="short-course-node-name">Name of Skill Node</label>
                        <div className="input-well">
                            <ControlledInput id="short-course-node-name" type="text" value={this.props.node.name} onChange={this.setNodeValue.bind(this,'name')}/>
                        </div>
                    </div>
                    <div className="formlike">
                        <label htmlFor="short-course-node-description">Description</label>
                        <div className="input-well">
                            <ControlledTextArea rows={4} id="short-course-node-description" type="text" value={this.props.node.description} onChange={this.setNodeValue.bind(this,'description')}/>
                        </div>
                    </div>
                    <div className="node-rsd">
                        <label>{'RSD ID:'}</label>
                        <span>{this.props.node.rsd_id||'none'}</span>
                        <button className="btn btn-primary" onClick={this.openRSDPicker}>{'edit'}</button>
                    </div>
                </div>
                <div className="formlike">
                    <ShortCourseActivityChooser
                        projects={this.props.projects}
                        activities={this.props.activities}
                        selectedActivities={selectedActivities}
                        templates={this.props.templates}
                        chooseButtonText={'Add Remedial Activity'}
                        chooseHandler={this.onAddActivity.bind(this,REMEDIAL_ACTIVITY_TYPES[0])}
                        secondButtonText={'Add Assessment Activity'}
                        secondButtonHandler={this.onAddActivity.bind(this,ASSESSMENT_ACTIVITY_TYPES[0])}
                        thirdButtonText={'Add Tutorial Activity'}
                        thirdButtonHandler={this.onAddActivity.bind(this,TUTORIAL_ACTIVITY_TYPES[0])}
                        thirdButtonDisabled={hasTutorialActivity}
                    />
                    <button className="btn btn-primary" onClick={()=>{this.openEditChatbotModal('add')} }>
                        {'Add Virtual Tutor Activity'}
                    </button>
                </div>
                
                {this.renderTutorialActivities()}
                {this.renderRemedialActivities()}
                {this.renderAssessmentActivities()}
                {this.renderPrerequisiteEditor()}
                {this.renderSubskills()}
                <SingleAssetInput
                    buttonOnly
                    browseText="Upload Image"
                    assetType="image"
                    assetRole="normal"
                    accept="image/*"
                    onChange={this.updateImage}
                    onError={this.updateImageOnError}
                    validateAssetType={AssetUtil.validateImageMimeType}
                    disabled={!!this.state.imageUpdateActionID}
                />
                { (this.state.edit_activity_id && !this.state.modalState)? 
                <EditActivityDetailsModal
                    closeHandler={()=>{this.setState({edit_activity_id:''})}}
                    modalTitleId="mzl-edit-activity-details"
                    modalTitle="Activity Details"
                    activity_type={this.getEditActivityType()}
                    score_categories={this.getEditActivityScoreCategories() || [] }
                    subskills={this.state.subskills}
                    subskill_relations={this.state.edit_subskill_relations}
                    onSetActivityType={this.onSetActivityType}
                    onSetSubskillValue={this.onSetSubskillValue}
                    app={this.app}
                    onSyncSubskills={this.onSyncSubskills}
                    activityTypes={this.props.activityTypes}
                />
                : null }
            </div>
        );
    }
    
    render() {
        var edit_subskill = _.find(this.state.subskills,{hash:this.state.subskill_hash});
        
        return (
            <Row className="short-course-node-editor-area">
                <GotoCommentIcon {...this.props.commentProps} navLoc={{type:ShortCourseConstants.NAV_TYPES.Node,id: this.props.node.node_id}} />
                {this.renderElements()}
                { ((this.state.modalState === 'subskillEditor') && edit_subskill) ? 
                <EditSubskillModal
                    channelId={this.props.channelId}
                    doc={this.state.doc}
                    subskill_hash={this.state.subskill_hash}
                    closeHandler={ () => {this.closeSubskillEditor()} }
                />
                : null }
                
                { (this.state.modalState === 'rsdPicker') ?
                <RSDPickerModal
                    channelId={this.props.channelId}
                    rsd_service_id={this.props.node.rsd_service_id}
                    rsd_id={this.props.node.rsd_id}
                    closeHandler={this.closeRSDPicker}
                    saveHandler={this.onSaveRSD}
                />
                : null }
                
                { (this.state.modalState === 'editChatbotActivity') ?
                <EditChatbotActivityModal
                    doc={this.state.doc}
                    node={this.props.node}
                    channelId={this.props.channelId}
                    shortCourseId={this.props.shortCourseId}
                    courseHash={this.props.courseHash}
                    chatData={this.state.modalData.data}
                    subskills={this.state.subskills}
                    saveHandler={ this.editChatbotSaveHandler }
                    closeHandler={ this.closeEditChatbotModal }
                    activityTypes={ this.props.activityTypes }
                    preview={this.state.modalData.preview}
                />
                : null }
            </Row>
        );
    }
    
}; // ShortCourseNodeEditor

ShortCourseNodeEditor.propTypes = propTypes;
ShortCourseNodeEditor.defaultProps = defaultProps;

export default ShortCourseNodeEditor;